var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUserRoundBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F6E7F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5455 13.8636C24.5455 16.6833 22.2515 18.9773 19.4318 18.9773C16.6122 18.9773 14.3182 16.6833 14.3182 13.8636C14.3182 11.044 16.6122 8.75 19.4318 8.75C22.2515 8.75 24.5455 11.044 24.5455 13.8636ZM27.6136 29.2045V25.4552C27.6136 22.4474 24.8615 20 21.4773 20H17.3864C14.0022 20 11.25 22.4474 11.25 25.4552V29.2045V30.2273V31.25H27.6136V30.2273V29.2045Z",
    fill: "#A614B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserRoundBig);
export default __webpack_public_path__ + "static/media/icon-user-round-big.a981dec270879c0d03c182dc02909b98.svg";
export { ForwardRef as ReactComponent };